import { render, staticRenderFns } from "./EvsForm.vue?vue&type=template&id=ce1242b4&scoped=true"
import script from "./EvsForm.vue?vue&type=script&lang=ts"
export * from "./EvsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1242b4",
  null
  
)

export default component.exports